/**
 *
 * ResultsSjTableHead
 *
 */

import React, { memo, FunctionComponent } from 'react';
import SortIndicatorComponent from '../../../../components/SortIndicator/SortIndicator.component';
import { Sort } from '../../../../domain';

interface IProps {
  changeSort: (field: string) => void;
  sort?: Sort;
  sjPhasesCount: number;
  disabledFields: string[];
}

const ResultsSJTableHead: FunctionComponent<IProps> = ({
  changeSort,
  sort,
  sjPhasesCount,
  disabledFields,
}) => {
  return (
    <thead>
      <tr>
        <th scope="col">
          <SortIndicatorComponent
            field="eaEventClassAndSort"
            name="Class"
            sort={sort}
            changeSort={changeSort}
            disabledFields={disabledFields}
          />
        </th>
        <th scope="col">
          <SortIndicatorComponent
            field="sectionName"
            name="Section"
            sort={sort}
            changeSort={changeSort}
            disabledFields={disabledFields}
          />
        </th>
        <th scope="col" colSpan={3}>
          <SortIndicatorComponent
            field="bridleNumber"
            name="Rider/BN"
            sort={sort}
            changeSort={changeSort}
            disabledFields={disabledFields}
          />
        </th>
        {[...Array(sjPhasesCount)].map((_, index) => (
          <React.Fragment key={index}>
            <th scope="col">
              <SortIndicatorComponent
                field={`phase${index + 1}JF`}
                name={`Phase ${index + 1} JF`}
                sort={sort}
                changeSort={changeSort}
                disabledFields={disabledFields}
              />
            </th>
            <th scope="col">
              <SortIndicatorComponent
                field={`phase${index + 1}TF`}
                name={`Phase ${index + 1} TF`}
                sort={sort}
                changeSort={changeSort}
                disabledFields={disabledFields}
              />
            </th>
            <th scope="col">
              <SortIndicatorComponent
                field={`phase${index + 1}F`}
                name={`Phase ${index + 1} F`}
                sort={sort}
                changeSort={changeSort}
                disabledFields={disabledFields}
              />
            </th>
            <th scope="col">
              <SortIndicatorComponent
                field={`phase${index + 1}RecTime`}
                name={`Phase ${index + 1} Rec Time`}
                sort={sort}
                changeSort={changeSort}
                disabledFields={disabledFields}
              />
            </th>
          </React.Fragment>
        ))}
        <th scope="col">
          <SortIndicatorComponent
            field="totalJFaults"
            name="Total Faults"
            sort={sort}
            changeSort={changeSort}
            disabledFields={disabledFields}
          />
        </th>
        <th scope="col">
          <SortIndicatorComponent
            field="sectionPlace"
            name="SP"
            sort={sort}
            changeSort={changeSort}
            disabledFields={disabledFields}
          />
        </th>
        <th scope="col">
          <SortIndicatorComponent
            field="sjPlace"
            name="OP"
            sort={sort}
            changeSort={changeSort}
            disabledFields={disabledFields}
          />
        </th>
        <th scope="col">
          <SortIndicatorComponent
            field="riderClassStatusName"
            name="Status"
            sort={sort}
            changeSort={changeSort}
            disabledFields={disabledFields}
          />
        </th>
      </tr>
    </thead>
  );
};

export default memo(ResultsSJTableHead);
